import { IssuesList } from './IssuesList';
import { IssueVisibilityType } from '@sonar-software/sonar-issues';
import React from 'react';

export const SnoozedIssuesList: React.FC = () => <IssuesList visibility={ IssueVisibilityType.Snoozed } />;
